import React, { Component } from 'react';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Typography, Grid, Button } from '@material-ui/core';

import { connect } from "react-redux";
import CreateCoursePlan from '../coursePlan/CreateCoursePlan';
import CreateCourseHeader from '../coursePlan/createCoursePlan/CreateCoursePlan';

const styles = (theme: Theme) => createStyles({
	center: {
		maxWidth: "315px",
		textAlign: "center"
	},
	img: {
		maxWidth: 163,
    	width: "100%",
	},
	button: {
		marginTop: "25px"
	},
	heading: {
		marginTop: "20px"
	}
});

interface NoContentProps extends WithStyles<typeof styles> {
	isPostExpiryDays: any;
	toggleLicenseExpiredDialog: any;
	handleComponentSwitching?: Function,
	classes: any, 
	match:any,
	history: any,
	handleNoContent?: boolean,
	noData?: boolean;
}

interface NoContentStates {
	createContentOpen: Boolean,
	isButton: boolean
}

class NoContent extends Component<NoContentProps, NoContentStates> {
	constructor(props: NoContentProps) {
		super(props);
		this.state = {
			createContentOpen: false,
			isButton: false,
		};
        

		this.createContentOpenHandler = this.createContentOpenHandler.bind(this);
		this.createContentCloseHandler = this.createContentCloseHandler.bind(this);
	}
    

	createContentOpenHandler = (event: any) => {
		
		if(this.props.isPostExpiryDays){
			this.props.toggleLicenseExpiredDialog(true);
		} else {
			this.setState({
				createContentOpen: true
			});
		}
	};

	createContentCloseHandler = (event: any) => {
		this.setState({
			createContentOpen: false
		});
	};

	onCreateCoursePlan = () => {
		return (
			<CreateCoursePlan match={this.props.match} history={this.props.history}/>
		)
	}
	renderNoContent =()=> {
		const { classes, handleComponentSwitching } = this.props;
		return (
			<>{this.state.isButton?this.onCreateCoursePlan():''}
			{!this.state.isButton?<>
			<CreateCourseHeader handleNoContent={false}/>
			<Grid container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					style={{ minHeight: '100vh' }}>
					<Grid item className={classes.center}>
						<img alt="no content" className={classes.img} src="/assets/img/mylibrary/no-content.png" />
						<Typography variant="h6" className={classes.heading} gutterBottom>No Course Plan</Typography>
						<Typography variant="caption" color="textSecondary" gutterBottom> There are no course Plans created Yet! </Typography>
							<Button
								className={classes.button}
								variant="contained"
								color="primary"
								// onClick={this.createContentOpenHandler.bind(this)}
								// onClick = {() => handleComponentSwitching ? handleComponentSwitching('CreateCoursePlan'):console.log('buttonclick')}
								onClick={()=> this.setState({isButton: true})}
							>
								Create Course Plan
						</Button>
					</Grid>
				</Grid></>:''}
			</>
		)
	  }
	  
	  noDataFoundAfterSearch = () => {
		const { classes } = this.props;
		const noResultFoundText = 'No result found!';
		const noResultText = 'There were no results matching the keywords you have entered';
		return (
			<>
				<Grid container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					style={{ minHeight: '50vh' }}>
					<Grid item className={classes.center}>
						<img alt="no content" className={classes.img} src="/assets/svg/no-data-phase-plan.svg" />
						<Typography variant="h6" gutterBottom>{noResultFoundText}</Typography>
						<Typography variant="caption" gutterBottom>{noResultText}</Typography>
					</Grid>
				</Grid>
			</>
		);
	}

	render() {
		
		const { classes , handleComponentSwitching} = this.props;
		const {
			createContentOpen,
		} = this.state;
		return (
			<>
			{this.props.noData ? this.noDataFoundAfterSearch(): this.renderNoContent()}
			</>
			// <>
			// 	{this.state.isButton?<CreateCoursePlan match={this.props.match} history={this.props.history} />:''}
			// 	{!this.state.isButton?<Grid container
			// 		spacing={0}
			// 		direction="column"
			// 		alignItems="center"
			// 		justify="center"
			// 		style={{ minHeight: '100vh' }}>
			// 		<Grid item className={classes.center}>
			// 			<img alt="no content" className={classes.img} src="/assets/img/mylibrary/no-content.png" />
			// 			<Typography variant="h6" className={classes.heading} gutterBottom>No Course Plan</Typography>
			// 			<Typography variant="caption" color="textSecondary" gutterBottom> There are no course Plans created Yet! </Typography>
			// 				<Button
			// 					className={classes.button}
			// 					variant="contained"
			// 					color="primary"
			// 					// onClick={this.createContentOpenHandler.bind(this)}
			// 					onClick = {() =>this.renderNoContent()
	
			// 					}
			// 					// onClick={this.onCreateCoursePlan}
		
			// 				>
			// 					Create Course Plan
			// 			</Button>
			// 		</Grid>
			// 	</Grid>:''}
				
			// </>
		)
	}
}

const mapStateToProps = (state: any) => ({
	isPostExpiryDays: state.loginData.userData.isPostExpiryDays
  });
  
  const mapDispatchToProps = {

  };

// @ts-ignore
export default connect(
	mapStateToProps,
	mapDispatchToProps
	// @ts-ignore
  )(withStyles(styles)(NoContent));